module.exports = __webpack_public_path__ + "img/11.b5d1ce33.png";